// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { DefaultApi, Instrument } from '@digitalasset/cn-token-metadata-api-ts-client';
import { useQuery } from '@tanstack/react-query';
import { useCNTokenMetadataApiClient } from '../../contexts/CNTokenMetadataApiContext';

const fetchInstrumentsFromAllPages = async (
  instruments: Instrument[],
  tokenMetadataClient: DefaultApi,
  currentPageToken?: string,
): Promise<Instrument[]> => {
  const result = await tokenMetadataClient.listInstruments(undefined, currentPageToken);

  instruments.push(...result.instruments);

  if (result.nextPageToken) {
    return fetchInstrumentsFromAllPages(instruments, tokenMetadataClient, result.nextPageToken);
  }

  return instruments;
};

export const useCNGetAllInstrumentConfigurations = () => {
  const tokenMetadataClient = useCNTokenMetadataApiClient();

  return useQuery({
    queryKey: [tokenMetadataClient, 'getCNInstrumentConfigurations'],
    queryFn: async () => {
      return fetchInstrumentsFromAllPages([], tokenMetadataClient);
    },
    refetchInterval: false,
  });
};
